import {ParamCodeExporter} from '../Param';
import {CodeExporterDispatcher} from '../Dispatcher';
import {TypedMultipleParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/_Multiple';
import {ParamType} from '../../../../../../@polygonjs/polygonjs/src/engine/poly/ParamType';
import {TypedNumericParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/_Numeric';

export class ParamMultipleCodeExporter extends ParamCodeExporter<TypedMultipleParam<ParamType>> {
	// as_code_default_value_string() {
	// 	let values = this._param.components.map((c) => c.value);
	// 	return `[${values.join(',')}]`;
	// }
	override add_main() {
		this._param.components.forEach((component) => {
			CodeExporterDispatcher.dispatch_param(component)
				.process()
				.forEach((component_line) => {
					this._lines.push(component_line);
				});
		});
	}
	override HTMLSnippet() {
		return this._param.components
			.map((c) => {
				return this._componentHTMLSnippet(c);
			})
			.join('\n');
	}
	override JSSnippet() {
		return this._param.components
			.map((c) => {
				return this._componentJSSnippet(c);
			})
			.join('\n');
	}
	private _componentHTMLSnippet(component: TypedNumericParam<ParamType>) {
		const range = component.options.range();
		const stepFloat = component.options.step() || 0.01;
		const step = component.type() == ParamType.INTEGER ? 1 : stepFloat;
		const id = this._HTMLId(component);
		const label = `<label for='${id}'>${id}</label>`;
		const numberInput = `<input type='number' id='${id}' name='${id}' min=${range[0] || 0} max=${
			range[1] || 1
		} step=${step} value=${component.value}></input>`;
		// const rangeInput = `<input type='range' id='${this._HTMLId()}' name='${this._HTMLId()}' min=${
		// 	range[0] || 0
		// } max=${range[1] || 1} step=${step} value=${this._param.value}></input>`
		return `${label}
${numberInput}`;
	}
	private _componentJSSnippet(component: TypedNumericParam<ParamType>) {
		const id = this._HTMLId(component);
		return `document.getElementById('${id}').addEventListener('input', function(event){
			scene.node('${component.node.path()}').p.${component.name()}.set(event.target.value);
		})`;
	}
}
